import { translate } from '../translate';

const formatMinutes = (minutes: number) => (minutes < 10 ? `0${minutes}` : minutes);

const generateLongFormText = (hours: number, minutes: number) => {
  if (hours === 0) {
    if (minutes === 1) return translate('ktxt_time_minute_long', { minutes });
    return translate('ktxt_time_minutes_long', { minutes });
  }

  if (minutes === 0) {
    if (hours === 1) return translate('ktxt_time_hour_long', { hours });
    return translate('ktxt_time_hours_long', { hours });
  }

  if (hours === 1) {
    if (minutes === 1) return translate('ktxt_time_hour_minute_long', { hours, minutes });
    return translate('ktxt_time_hour_minutes_long_corrected', { hours, minutes });
  }

  if (minutes === 1) return translate('ktxt_time_hours_minute_long', { hours, minutes });
  return translate('ktxt_time_hours_minutes_long', { hours, minutes });
};

const generateShortFormText = (hours: number, minutes: number) => {
  if (minutes > 0) {
    return translate('ktxt_time_hours_minutes_short', {
      hours,
      minutes: formatMinutes(minutes),
    });
  }

  return translate('ktxt_time_hours', { hours });
};

export const parseFlightDurationToString = (
  {
    duration,
  }: {
    duration: number;
  },
  useLongForm: boolean = false,
): string => {
  const hours = Math.floor(duration / 60);
  const minutes = duration % 60;

  return useLongForm ? generateLongFormText(hours, minutes) : generateShortFormText(hours, minutes);
};
